import axios from "axios";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Routers from "./routes/Router";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./store/auth";
import useTokenAutoRefresh from "./hooks/useTokenAutoRefresh";
import { useEffect } from "react";
import IframeWidget from "./components/widgets/IframeWidget";
import RoleSelectionModal from "./components/RoleSelectionModal";

function App() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const hasMultipleRoles = () => {
    if (!user || !user.idToken) return false;
    let count = 0;
    if (user.is_supervisor) count++;
    if (user.is_tl) count++;
    if (user.is_tc) count++;
    if (user.is_fa) count++;
    if (user.is_agency) count++;
    return count > 1;
  };

  const needsRoleSelection = hasMultipleRoles() && !user.selectedRole;
  
  axios.defaults.baseURL = "https://uat.collecteaze.ai/";
  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response?.status === 401) {
        dispatch(logout());
        window.location.href = "/sign-in";
      }
      return Promise.reject(err);
    }
  );
  useTokenAutoRefresh();
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const modals = document.querySelectorAll(".ant-modal");
      const html = document.documentElement;

      // Check if any modal is visible
      const anyModalVisible = Array.from(modals).some(
        (modal) => window.getComputedStyle(modal).display !== "none"
      );

      if (anyModalVisible) {
        html.style.overflow = "hidden";
      } else {
        html.style.overflow = "";
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true, // Also observe attribute changes (like style)
      attributeFilter: ["style", "class"],
    });

    return () => observer.disconnect();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        {!needsRoleSelection && <Routers />}
        {!needsRoleSelection && <IframeWidget />}
        <RoleSelectionModal />
      </BrowserRouter>
    </div>
  );
}

export default App;
